import { render, staticRenderFns } from "./status_icon.vue?vue&type=template&id=64198c22"
import script from "./status_icon.vue?vue&type=script&lang=js"
export * from "./status_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports